import React, { useState, useEffect } from 'react';

function PasswordStrengthErrors({ password,  anyErrors }) {
    const [errors, setErrors] = useState({
        minLength: false,
        maxLength: false,
        upperCase: false,
        special: false,
        number: false,
        lowerCase: false
    });

    useEffect(() => {
        let errors = validate(password)
        setErrors(errors);
        anyErrors(errors.minLength || errors.maxLength || errors.upperCase || errors.lowerCase || errors.number)
    }, [password])

    const validate = (password) => {
        let errors = {
            minLength: false,
            maxLength: false,
            upperCase: false,
            // special: false,
            number: false,
            lowerCase: false
        };
        if (password.length < 5) errors.minLength = true;
        if (password.length > 12) errors.maxLength = true;
        if (!/[A-Z]/.test(password)) errors.upperCase = true;
        // if (!/[!@#$%^&*]/.test(password)) errors.special = true;
        if (!/[0-9]/.test(password)) errors.number = true;
        if (!/[a-z]/.test(password)) errors.lowerCase = true;
        return errors;
    }

    return (
        <>
            {password && errors.minLength && <p style={{ color: 'red' }}>Password should have at least 5 characters.</p>}
            {password && errors.maxLength && <p style={{ color: 'red' }}>Password should have at most 12 characters.</p>}
            {password && errors.upperCase && <p style={{ color: 'red' }}>Password should contain at least one uppercase letter.</p>}
            {/*{errors.special && <p style={{ color: 'red' }}>Password should contain at least one special character.</p>}*/}
            {password && errors.number && <p style={{ color: 'red' }}>Password should contain at least one number.</p>}
            {password && errors.lowerCase && <p style={{ color: 'red' }}>Password should contain at least one lowercase letter.</p>}
        </>
    );
}

export default PasswordStrengthErrors;
